import { useState, useEffect, useMemo, useReducer } from "react";
import { ToastContainer} from "react-toastify";
import {
  GetConfig,
  GetPaymentServiceDetails,
  GetMembershipDetails,
  GetAllowedPlans,
} from "../Settings/Requests";
import "../OnlineBooking/OnlineBooking.css"
import Payments from "../OnlineBooking/Payments";
import { useTranslation } from "react-i18next";

const PaymentsPage = () => {

  const { t, i18n } = useTranslation("settings");
  const [config, setConfig] = useState()
  const [paymentServiceDetails, setPaymentServiceDetails] = useState();
  const [hasStripeBalance, setHasStripeBalance] = useState()
    const [isLoading, setIsLoading] = useState(true);
  const [membershipError, setMembershipError] = useState("");
  const [membership, setMembership] = useState(null);
  const [membershipLoading, setMembershipLoading] = useState(false);
  const [availablePlans, setAvailablePlans] = useState()
  const [terms, setTerms] = useState();
  const [status, setStatus] = useState("null");

    useEffect(() => {
      GetConfigWrapper();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

  function GetPaymentServiceDetailsWrapper() {
    GetPaymentServiceDetails().then((res) => {
      if (res.status === 200) {
        setPaymentServiceDetails(res.data);
        const calculateHasStripeBalance =
          (res.data?.availableFunds ?? 0) > 0 ||
          (res.data?.pendingFunds ?? 0) > 0;
                setHasStripeBalance(calculateHasStripeBalance)
      }

    }).finally(()=>{
      GetSubscriptionDetailsWrapper()
    })
  }

    function GetSubscriptionDetailsWrapper()
  {
    loadMembership();
  }

    async function loadMembership() {
      setMembershipError("");
      setMembershipLoading(true);
      try {
        const res = await GetMembershipDetails();
        setMembership(res.data);
      } catch (e) {
        setMembership(null);
        setMembershipError(t('account.membership.errors.loadMembership'));
      } finally {
        setMembershipLoading(false);
        GetAllowedPlansWrapper()
      }
    }

      async function GetAllowedPlansWrapper() {
        try {
          const res = await GetAllowedPlans();
          setAvailablePlans(res.data)
        } catch (e) {
        } finally {
          setIsLoading(false);
        }
      }


        function GetConfigWrapper() {
          GetConfig()
            .then((res) => {
              setConfig(res.data);
              setTerms(res.data.terms);
              if (!res.data.payoutsEnabled) setStatus("no payouts");
              if (!res.data.chargesEnabled) setStatus("no charges");
              if (res.data.payoutsEnabled && res.data.chargesEnabled) setStatus("Connected");
            })
            .catch(() => {
              // optionally toast
            })
            .finally(() => {
              GetPaymentServiceDetailsWrapper();
            });
        }


  return (
          <div className="payment-page-wrapper">
            <ToastContainer />
            {!isLoading ?
                      <Payments
            setLoading={setIsLoading}
            getConfig={GetConfigWrapper}
            paymentServiceDetails={paymentServiceDetails}
            status={status}
            config={config}
            GetPaymentServiceDetails={GetPaymentServiceDetailsWrapper}
            ShowBookingPortalLink={false}
            ShowPaymentPanel={true}
          />
          :
          <div className="custom-loader-wrapper">
                  <div className="custom-loader"></div>
                </div>
            }

          </div>
  );
}

export default PaymentsPage;


